import React, { useEffect, useRef, useState } from 'react';
import styles from './AnimatedContainer.module.scss';

interface AnimatedContainerProps {
	isVisible: boolean;
	children: React.ReactNode;
}

export const AnimatedContainer: React.FC<AnimatedContainerProps> = ({ isVisible, children }) => {
	const containerRef = useRef<HTMLDivElement>(null);
	const [height, setHeight] = useState<number>(0);

	useEffect(() => {
		if (isVisible && containerRef.current) {
			setHeight(containerRef.current.scrollHeight);
		} else {
			setHeight(0);
		}
	}, [isVisible]);

	return (
		<div
			ref={containerRef}
			className={`${styles.container} ${isVisible ? styles.visible : ''}`}
			style={{ height: `${height}px` }}
		>
			{children}
		</div>
	);
};